import { props } from '../hard-token-integration-properties';
import { maxTokenCount } from '../max-token-count';

export class Controller {

    /** @ngInject */
    constructor($scope) {
        this.$scope = $scope;
    }

    $onInit() {
        this.$scope.$watch('form.$valid', (valid) => {
            this.valid = valid;
            this.changed();
        });
    }

    get props() {
        return props[this.type][this.otpType];
    }

    addToken() {
        this.tokens = [...this.tokens, {}];
        this.changed();
    }

    addTokenDisabled() {
        return this.tokens.length >= maxTokenCount;
    }

    remove(token) {
        this.tokens = this.tokens.filter((t) => t !== token);
        this.changed();
    }

    changed() {
        this.onChange({tokens: this.tokens, valid: this.valid});
    }

    getErrorMessage(form) {
        if (form.$error.pattern) {
            const propName = form.$error.pattern[0].$name;
            return `hard_tokens.integrate.validation.${this.type}.${this.otpType}.${propName}`;
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-integration/hard-token-importer-table/hard-token-importer-table.controller.js